import React from 'react';
import PropTypes from 'prop-types';
// TODO: cookie compliance?
// import { CookieCompliance, CookieComplianceCategories } from '@deporvillage/utils-library-component';
import Script from 'next/script';

export const RunneaConversion = ({
    id,
    amount,
    orderId,
    productIds,
    enabled,
}) => enabled && (
    <Script
        id={'runnea-conversion'}
        src={`https://www-ads.gembiratech.com/php/comprado.js.php?value=${amount}&id_pedido=${orderId}$afiliateID=${id}&products=${productIds.join(',')}`}
        strategy={'lazyOnload'}
        referrerpolicy={'strict-origin-when-cross-origin'}
    />
) || null;
RunneaConversion.propTypes = {
    id: PropTypes.string,
    amount: PropTypes.number,
    orderId: PropTypes.number,
    productIds: PropTypes.arrayOf(PropTypes.number),
    enabled: PropTypes.bool,
};

const Runnea = ({ enabled }) => enabled && (
    <Script
        id={'runnea'}
        src={'//www-ads.gembiratech.com/php/pixel.js.php'}
        strategy={'lazyOnload'}
        referrerpolicy={'strict-origin-when-cross-origin'}
    />
) || null;
Runnea.propTypes = {
    enabled: PropTypes.bool,
};

export default Runnea;
